var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportStepOneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.457,
    height: 20.758,
    viewBox: "0 0 22.457 20.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload_files",
    "data-name": "Upload files",
    transform: "translate(-593.543 -739.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M18.264,23.821A6.505,6.505,0,0,0,6.211,21.66a3.726,3.726,0,0,0-.683-.065,3.565,3.565,0,0,0-3.56,3.56,3.892,3.892,0,0,0,.074.739A4.955,4.955,0,0,0,0,29.889a5.3,5.3,0,0,0,1.344,3.505,4.8,4.8,0,0,0,3.325,1.672H8.677a.623.623,0,0,0,0-1.247H4.724a3.932,3.932,0,0,1-3.477-3.934A3.7,3.7,0,0,1,3.08,26.7a.629.629,0,0,0,.272-.757,2.262,2.262,0,0,1-.139-.794,2.318,2.318,0,0,1,2.314-2.314,2.274,2.274,0,0,1,.79.139.626.626,0,0,0,.78-.319,5.258,5.258,0,0,1,9.989,1.732.623.623,0,0,0,.517.554,4.494,4.494,0,0,1-.425,8.876h-3.4a.623.623,0,0,0,0,1.247h3.473a5.525,5.525,0,0,0,3.7-1.829,5.748,5.748,0,0,0-2.688-9.411Z",
    transform: "translate(593.543 720.842)",
    fill: "#ff8200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M165.89,189.769a.621.621,0,0,0,0-.882l-3.3-3.3a.631.631,0,0,0-.439-.185.612.612,0,0,0-.439.185l-3.3,3.3a.626.626,0,0,0,.439,1.067.608.608,0,0,0,.439-.185l2.24-2.24v10.293a.623.623,0,1,0,1.247,0V187.529l2.24,2.24A.616.616,0,0,0,165.89,189.769Z",
    transform: "translate(442.625 561.554)",
    fill: "#ff8200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportStepOneIcon);
export default __webpack_public_path__ + "static/media/import-step-one-icon.d0c938fe3c2f765d7e0888365eab9343.svg";
export { ForwardRef as ReactComponent };